import React, { useState } from "react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { ShieldCheck, Download, AlertTriangle, Info } from "lucide-react";

export default function BackupPage() {
  const [downloading, setDownloading] = useState(false);

  const downloadBackup = async () => {
    // Note: A real backend endpoint would produce a dump zip. For now we display info.
    setDownloading(true);
    setTimeout(() => setDownloading(false), 800);
    alert("Backup manual: hubungi tim admin server untuk snapshot di /app/backups/. UI upload/restore akan hadir di update mendatang.");
  };

  return (
    <div className="space-y-6 max-w-3xl">
      <div>
        <h1 className="text-2xl font-bold text-slate-800 flex items-center gap-2"><ShieldCheck className="h-6 w-6 text-emerald-600" /> Backup / Restore</h1>
        <p className="text-sm text-slate-500">Kelola cadangan data madrasah.</p>
      </div>

      <Card className="bg-amber-50 border-amber-200">
        <CardContent className="py-4 flex gap-3">
          <AlertTriangle className="h-5 w-5 text-amber-600 shrink-0" />
          <div>
            <p className="font-semibold text-amber-900">Aturan Keselamatan Data</p>
            <p className="text-sm text-amber-800 mt-1">Fitur restore <b>tidak</b> menghapus data yang ada. Backup rutin sudah tersedia via script server; UI upload/restore akan disediakan bertahap.</p>
          </div>
        </CardContent>
      </Card>

      <Card>
        <CardHeader><CardTitle className="text-base">Snapshot Manual</CardTitle></CardHeader>
        <CardContent className="space-y-3">
          <p className="text-sm text-slate-600">Snapshot MongoDB tersimpan otomatis di server (`/app/backups/`). Untuk backup rutin, jalankan script:</p>
          <pre className="bg-slate-900 text-emerald-300 text-xs p-3 rounded overflow-auto">bash /app/scripts/backup_mongo.sh manual</pre>
          <Button onClick={downloadBackup} disabled={downloading} className="bg-emerald-600 hover:bg-emerald-700">
            <Download className="h-4 w-4 mr-1" /> Info Backup
          </Button>
        </CardContent>
      </Card>

      <Card>
        <CardHeader><CardTitle className="text-base flex items-center gap-2"><Info className="h-4 w-4" /> Panduan</CardTitle></CardHeader>
        <CardContent className="text-sm text-slate-600 space-y-2">
          <p><b>1.</b> Backup manual disimpan pada folder <code>/app/backups/</code> dengan timestamp.</p>
          <p><b>2.</b> Jangan pernah jalankan <code>db.dropDatabase()</code> atau <code>delete_many({})</code> tanpa filter — gunakan Import/Export untuk data test.</p>
          <p><b>3.</b> Restore hanya dilakukan oleh admin server dengan konfirmasi tertulis dari pengelola.</p>
        </CardContent>
      </Card>
    </div>
  );
}
